import { CompanyDetailsPOST } from '@interfaces/Company.interface';

export function nullIfEmpty(obj: { [key: string]: unknown }) {
  const newObj = { ...obj };
  Object.keys(obj).forEach((key) => {
    newObj[key] = obj[key] === '' ? null : obj[key];
  });
  return newObj;
}
export function stripIfEmpty(obj: { [key: string]: unknown }) {
  const newObj: { [key: string]: unknown } = {};
  Object.keys(obj).forEach((key) => {
    const v = obj[key];
    if (v && v !== '') {
      newObj[key] = obj[key];
    }
  });
  return newObj;
}
export type ObjectValues<T> = T[keyof T];

// eslint-disable-next-line
type Fields = { [key: string]: any };

export function getFilteredFields(
  fields: Fields,
  isChecked: boolean
): CompanyDetailsPOST {
  const newFields = { ...fields };

  if ('type_other' in newFields) {
    delete newFields.type_other;
  }

  if (isChecked) {
    if (typeof fields.address === 'string' && fields.address.trim() !== '') {
      newFields.trading_address = fields.address;
    } else {
      delete newFields.trading_address;
    }
  }

  return newFields as CompanyDetailsPOST;
}
